import {skipWaiting as workbox_core_skipWaiting} from 'C:/_Fuentes/LD_EXPRESS/FUENTES/EXPRESS WEB/EXPRESS WEB/ClientApp/node_modules/workbox-core/skipWaiting.mjs';
import {clientsClaim as workbox_core_clientsClaim} from 'C:/_Fuentes/LD_EXPRESS/FUENTES/EXPRESS WEB/EXPRESS WEB/ClientApp/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'C:/_Fuentes/LD_EXPRESS/FUENTES/EXPRESS WEB/EXPRESS WEB/ClientApp/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








workbox_core_skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "./ClientApp/public/dist/0.fc07d78ff3d6abbe2089.js",
    "revision": "63abdde8e734924d7db73f11bfa55401"
  },
  {
    "url": "./ClientApp/public/dist/0.fc07d78ff3d6abbe2089.js.map",
    "revision": "9f801649c1241d3ac614eaff70c682b2"
  },
  {
    "url": "./ClientApp/public/dist/1.6872f6ce971f9479fee6.js",
    "revision": "de5674f4edb427bf54bc164b3c96fb2f"
  },
  {
    "url": "./ClientApp/public/dist/1.6872f6ce971f9479fee6.js.map",
    "revision": "aa075c1b25535c16e0858224a0f43cbf"
  },
  {
    "url": "./ClientApp/public/dist/10.47909b432dbca2341bd2.js",
    "revision": "965f9a8c5add0965ceb323193775039a"
  },
  {
    "url": "./ClientApp/public/dist/10.47909b432dbca2341bd2.js.map",
    "revision": "abca6f7bd20afdf31d239a80c51e8dd3"
  },
  {
    "url": "./ClientApp/public/dist/11.3dd6031bf8fc4126c3e9.js",
    "revision": "12a1c899b0a6497a7a7b9b2d15e4962e"
  },
  {
    "url": "./ClientApp/public/dist/11.3dd6031bf8fc4126c3e9.js.map",
    "revision": "885bf673091e187b58a730d9eaa81a80"
  },
  {
    "url": "./ClientApp/public/dist/12.97496bb13fa1434bebe0.js",
    "revision": "72f9a026ff58ce3697b12da93c6bfe9b"
  },
  {
    "url": "./ClientApp/public/dist/13.bff5e036fad88ec50d86.js",
    "revision": "e5d575e77d7dd718b631ccbbd7cef474"
  },
  {
    "url": "./ClientApp/public/dist/14.e2971525fa7c55b7e1c5.js",
    "revision": "5e0c7e462df9b1995cea8c192784a865"
  },
  {
    "url": "./ClientApp/public/dist/14.e2971525fa7c55b7e1c5.js.map",
    "revision": "99cd1c3980a11c60b17c940ed85c0344"
  },
  {
    "url": "./ClientApp/public/dist/15.abbab6634dd97eb345dc.js",
    "revision": "97289132f6d3e2d4f1efa3605af80dc6"
  },
  {
    "url": "./ClientApp/public/dist/15.abbab6634dd97eb345dc.js.map",
    "revision": "1fb6601f7aae78c715a05e5b95e36d74"
  },
  {
    "url": "./ClientApp/public/dist/16.a1ab709d831176378e59.js",
    "revision": "5ded246a9d54c4af86838b8addc8bca0"
  },
  {
    "url": "./ClientApp/public/dist/16.a1ab709d831176378e59.js.map",
    "revision": "8bca54e71a2a2ca18d0d5b318fed4ff2"
  },
  {
    "url": "./ClientApp/public/dist/17.c1c37f53fbf52d43dacc.js",
    "revision": "24a6409457b8c45da0d3bfc313d0d584"
  },
  {
    "url": "./ClientApp/public/dist/17.c1c37f53fbf52d43dacc.js.map",
    "revision": "21953ab1b8011e58974086802e585101"
  },
  {
    "url": "./ClientApp/public/dist/18.d2ee7ef6e20c1b5010fb.js",
    "revision": "89a43652fd73297d1cb8d81a628010a9"
  },
  {
    "url": "./ClientApp/public/dist/18.d2ee7ef6e20c1b5010fb.js.map",
    "revision": "f7cbd81cea1e7d41b873decc1d345023"
  },
  {
    "url": "./ClientApp/public/dist/19.5b7384f0864a91b9b8f3.js",
    "revision": "823d71d92d53320eabed894d78f1011b"
  },
  {
    "url": "./ClientApp/public/dist/19.5b7384f0864a91b9b8f3.js.map",
    "revision": "d9f9d19693db0ce92abf1263c76d7302"
  },
  {
    "url": "./ClientApp/public/dist/2.7bb108260d48ec79855c.js",
    "revision": "6552f4c482ad23491d65995a34cceb25"
  },
  {
    "url": "./ClientApp/public/dist/2.7bb108260d48ec79855c.js.map",
    "revision": "6f6e0ccfbbb0d78ff1a73139639eac53"
  },
  {
    "url": "./ClientApp/public/dist/20.d522ea30bf1966b4ab82.js",
    "revision": "4580320b311a4462720e651afcf5138b"
  },
  {
    "url": "./ClientApp/public/dist/20.d522ea30bf1966b4ab82.js.map",
    "revision": "7ee840cf1aa1ac2cc84e8fb6e4a2bc8e"
  },
  {
    "url": "./ClientApp/public/dist/21.86626c103b53db8e5c2e.js",
    "revision": "9a99984cbdbec838e85ee0f41c3bb7c0"
  },
  {
    "url": "./ClientApp/public/dist/21.86626c103b53db8e5c2e.js.map",
    "revision": "0cb8f0efca454a05336a89161cf484a9"
  },
  {
    "url": "./ClientApp/public/dist/22.8a6d03f7ea7921bdd768.js",
    "revision": "eee0396ce6a3da77974cfb541f470b9d"
  },
  {
    "url": "./ClientApp/public/dist/22.8a6d03f7ea7921bdd768.js.map",
    "revision": "26aad7e538d1f3efbb8c05d5bda14767"
  },
  {
    "url": "./ClientApp/public/dist/23.989e3f52f7c3174316d6.js",
    "revision": "d2998bd571cad6ac42f714df32cfb7ca"
  },
  {
    "url": "./ClientApp/public/dist/23.989e3f52f7c3174316d6.js.map",
    "revision": "1355b42c709e75be67027f10426e105a"
  },
  {
    "url": "./ClientApp/public/dist/24.36b5a61f5b7e12b0af4e.js",
    "revision": "0d5067405f87e9b1b544d7ab433942fb"
  },
  {
    "url": "./ClientApp/public/dist/24.36b5a61f5b7e12b0af4e.js.map",
    "revision": "6a78c1ae7d0acdcdb57eac26083c1beb"
  },
  {
    "url": "./ClientApp/public/dist/25.ea9538ca737adf08f4b2.js",
    "revision": "8cf95e2874881e4c27b5230305d9b306"
  },
  {
    "url": "./ClientApp/public/dist/25.ea9538ca737adf08f4b2.js.map",
    "revision": "ffca7994f41293844238f004155e9820"
  },
  {
    "url": "./ClientApp/public/dist/26.5ab4fda9f8b747db5dcc.js",
    "revision": "ff1fbe64e2b5054078d3604cad6cda1c"
  },
  {
    "url": "./ClientApp/public/dist/26.5ab4fda9f8b747db5dcc.js.map",
    "revision": "80047b9eba78025252484a01ee4b5ddd"
  },
  {
    "url": "./ClientApp/public/dist/27.b2b60637453a14ed10a9.js",
    "revision": "ce956d1a58876e2c2e3163f4df06d5c6"
  },
  {
    "url": "./ClientApp/public/dist/27.b2b60637453a14ed10a9.js.map",
    "revision": "6da30eea703ca2b6cfa8d582e4b43fdd"
  },
  {
    "url": "./ClientApp/public/dist/28.1cfef8dea8aaa1ad0b77.js",
    "revision": "c271c7a829be2b442aa12c1516164bee"
  },
  {
    "url": "./ClientApp/public/dist/28.1cfef8dea8aaa1ad0b77.js.map",
    "revision": "3d0a420bec11946f22534d554264f4c9"
  },
  {
    "url": "./ClientApp/public/dist/29.23be77731e8ad651b285.js",
    "revision": "6f35b89fabe8e4e395cbcfa3bb11442f"
  },
  {
    "url": "./ClientApp/public/dist/29.23be77731e8ad651b285.js.map",
    "revision": "78a5b2fdba1ef358766cdfb9005a1f8b"
  },
  {
    "url": "./ClientApp/public/dist/3.7e3afb63d49348877c28.js",
    "revision": "9a3477e50377b78d68ce80c2f8ad0e6a"
  },
  {
    "url": "./ClientApp/public/dist/3.7e3afb63d49348877c28.js.map",
    "revision": "cb0f48b034620ed4e5c1793de55b3ee2"
  },
  {
    "url": "./ClientApp/public/dist/30.b766f137078f6d711650.js",
    "revision": "8b89133616856ec04dca9c5a520eb1bc"
  },
  {
    "url": "./ClientApp/public/dist/30.b766f137078f6d711650.js.map",
    "revision": "f4133592f6a0c03a8608a1df185c252a"
  },
  {
    "url": "./ClientApp/public/dist/4.f3225792d0cbb88f7de9.js",
    "revision": "6bae1ad7d8c137a6abc211dd1ee8f26f"
  },
  {
    "url": "./ClientApp/public/dist/4.f3225792d0cbb88f7de9.js.map",
    "revision": "28c43105adbb3f4245f2a4a47252f9d7"
  },
  {
    "url": "./ClientApp/public/dist/5.50bbdd33909622cb99ab.js",
    "revision": "1fd17689dbaa3b8d64e957f0ec462b7c"
  },
  {
    "url": "./ClientApp/public/dist/5.50bbdd33909622cb99ab.js.map",
    "revision": "bff185caa9956661247dd798fbe00daa"
  },
  {
    "url": "./ClientApp/public/dist/6.ceba59c63ae6ce841a6c.js",
    "revision": "5a2427fbacd2b65163e5c6d946284cee"
  },
  {
    "url": "./ClientApp/public/dist/6.ceba59c63ae6ce841a6c.js.map",
    "revision": "6ad790a29384e85d7124db837ef17dcb"
  },
  {
    "url": "./ClientApp/public/dist/7.084819808ec665c0ea34.js",
    "revision": "b43c99f1e4e6aa733234657f00b29106"
  },
  {
    "url": "./ClientApp/public/dist/7.084819808ec665c0ea34.js.map",
    "revision": "7a2cd6fb38c90e1a88142b5e6e7034b4"
  },
  {
    "url": "./ClientApp/public/dist/app.47ef05b712407d10973e.js",
    "revision": "48dc6bb80334f938391121916ecc7d58"
  },
  {
    "url": "./ClientApp/public/dist/app.47ef05b712407d10973e.js.map",
    "revision": "d99dacfc8293bf51d252bf94486c05e6"
  },
  {
    "url": "./ClientApp/public/dist/runtimechunk~app.ac31191b62d00b512f6d.js",
    "revision": "866ff85c4ab554328c049e475d34b9ed"
  },
  {
    "url": "./ClientApp/public/dist/runtimechunk~app.ac31191b62d00b512f6d.js.map",
    "revision": "a88b64ba8e37b70df1ad1a1840bb3344"
  }
], {});








